import {Button} from "@mui/material"

const BadgeTextMapReceived = {
	"article_share": "Articles viewed",
	"workspace_add": "Workspace Joined",
	"workspace_invite": "Invite Accepted",
	"workspace_inv_res": "Member Added",
	"post_reg_inv": "Request Sent",
}

const BadgeTextMapSent = {
	"article_share": "User viewed Articles",
	"workspace_add": "User joined Workspace",
	"workspace_invite": "Invite Sent",
	"workspace_inv": "Invite Sent",
	"workspace_inv_res": "Added Member to Workspace",
	"post_reg_inv": "Added Member to Workspace",
}


export default function NotificationStatusBadge({sharedCitationObject}) {
	const sentByUser = sharedCitationObject.isSent

	return (
		<Button
			variant={"text"}
			disableRipple
			size={"small"}
			//color={"otherInfo"}
			sx={{
				backgroundColor: "none",
				cursor: "default",
				//margin: "0 10px 2px 0",
				textTransform: "none",
				//padding: "1px 50px",
				transition: "background-color color 250ms ease-in",
				"&:hover": {
					backgroundColor: "primary.transparency20",
					color: "alertRed.mainTransparency100",
				},
				color: "alertRed.main",
			}}
		>
			{sentByUser ? BadgeTextMapSent[sharedCitationObject.type] : BadgeTextMapReceived[sharedCitationObject.type]}
		</Button>
	)
}